export default {
  namespaced: false,
  state: {
    scroll: true,
    theme: 'darkTheme',
    showAnalytics: true,
    onboardingNotification: false,
    onboardingGroupsModal: false,
  },
  mutations: {
    SET_SCROLL(state, payload) {
      state.scroll = payload
      for (const className of ['tw-size-full', 'tw-relative', 'tw-overflow-hidden']) {
        document.body.classList.toggle(className, !payload)
      }
    },
    SET_THEME(state, payload) {
      document.documentElement.className = payload
      localStorage.theme = payload
      state.theme = payload
    },
    SET_SHOWANALYTICS(state, payload) {
      state.showAnalytics = payload
    },
    SET_ONBOARDING_NOTIFICATION(state, payload) {
      if (!payload) {
        localStorage.setItem('ignoredOnboardingNotification', JSON.stringify(true))
      }

      state.onboardingNotification = payload
    },
    SET_ONBOARDING_GROUPS_MODAL(state, payload) {
      state.onboardingGroupsModal = payload
    },
  },
  getters: {
    theme(state) {
      return state.theme
    },
  },
}
